module.exports = __webpack_public_path__ + "static/media/infor_client.6e2395c4.svg";